import { Button, Row, Col, Typography, Space } from "antd"
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import axios from "axios";
import dayjs from 'dayjs'

const Recorder = ({
    onReceive = () => { },
    onVolumeChange = () => { },
    onChange = () => { },
    // mode = "debug",
    mode = "release",
    startTitle = "start",
    startProps = {},
    endTitle = "end",
    endProps = {},
    forceRecord = false,
    setFroceRecord = () => { },
    forceStopRecord = false,
    setForceStopRecord = () => { }
}) => {
    const [recording, setRecording] = useState(false)
    const [output, setOutput] = useState([])
    const [preview, setPreview] = useState('')
    const wsRef = useRef();
    const audioContextRef = useRef();
    const recorderRef = useRef();
    const audioInputRef = useRef();
    const inputDataRef = useRef([]);
    const streamRef = useRef([]);
    const sizeRef = useRef(0);

    // ------------------------------------------
    const [volume, setVolume] = useState('null') // 介面文字顯示
    const [chunkVolume, setchunkVolume] = useState('null')
    const analyser = useRef(); // 分析音量大小
    const gainNode = useRef(); // 用來儲存 GainNode 控制音量
    const [dataArray, setDataArray] = useState([]) // 儲存聲音用來計算用
    function getCurrentVolume() {
        try {
            analyser.current.getByteFrequencyData(dataArray);
            // 計算所有音頻的平均值，即為目前音量
            let sum = 0;
            for (let i = 0; i < dataArray.length; i++) {
                sum += dataArray[i];
            }
            const average = sum / dataArray.length;
            setVolume(average)
            // console.log('目前音量大小:', average);
            if (average <= 5) {
                onVolumeChange(1, average) // 太小聲或沒聲音
            } else if (average > 5 && average <= 10) {
                onVolumeChange(2, average) // 小聲
            } else if (average > 10 && average <= 20) {
                onVolumeChange(3, average) // 正常
            } else if (average > 20 && average <= 25) {
                onVolumeChange(4, average) // 大聲
            } else if (average > 25) {
                onVolumeChange(5, average) // 太大聲
            }

        } catch (error) {
        }

    }
    setInterval(function () {
        getCurrentVolume();

    }, 1000);

    const start = () => {
        setRecording(true)
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 });
        analyser.current = audioContextRef.current.createAnalyser() // 建立 Analyser
        setDataArray(new Uint8Array(analyser.current.frequencyBinCount))
        inputDataRef.current = []
        sizeRef.current = 0
        recorderRef.current = audioContextRef.current.createScriptProcessor(16 * 1024, 1, 1);//chunk大小
        recorderRef.current.onaudioprocess = function (e) {

            var data = e.inputBuffer.getChannelData(0);//單聲道資料
            var sum = 0;
            for (var i = 0; i < data.length; i++) {
                sum += data[i];
            }
            // 計算平均值
            var average = sum / data.length;
            setchunkVolume(average)
            console.log("錄音大小:", average);

            inputDataRef.current.push(new Float32Array(data));//資料塞成array
            sizeRef.current += data.length;//chunk大小
            wsRef.current.send(encodePCM())//把audio轉欓成pcm data
            /* 歸零 */
            inputDataRef.current = []
            sizeRef.current = 0
        }

        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream) => {
            // console.log('聲音輸入...')
            streamRef.current = stream
            gainNode.current = audioContextRef.current.createGain(); // 建立 gainNode
            audioInputRef.current = audioContextRef.current.createMediaStreamSource(stream);
            audioInputRef.current.connect(gainNode.current); // 聲音串連 gainNode
            // 如果需要聽到自己的聲音，下面可取消註解
            // gainNode.current.connect(audioContextRef.current.destination);
            gainNode.current.connect(analyser.current) // 聲音串連 analyser
            analyser.current.fftSize = 256
        }).catch((err) => {
            // console.log(err);
        }).then(function () {
            // 將音訊流串連到 gainNode 來做音訊放大調整
            gainNode.current.gain.value = 6
            audioInputRef.current.connect(gainNode.current);
            // gainNode 再去串連錄音
            gainNode.current.connect(recorderRef.current)
            recorderRef.current.connect(audioContextRef.current.destination);
        });
    }
    const end = () => {
        setRecording(false)
        recorderRef.current?.disconnect();
        if (streamRef.current.length != 0) {
            streamRef.current?.getTracks()?.[0]?.stop()
            if (0 !== sizeRef.current) {
                wsRef.current.send(encodePCM())
                inputDataRef.current = []
                sizeRef.current = 0
            }
        }
    }

    var oututSampleBits = 16;
    function decompress() {
        var data = new Float32Array(sizeRef.current);
        var offset = 0;
        for (var i = 0; i < inputDataRef.current.length; i++) {
            data.set(inputDataRef.current[i], offset);
            offset += inputDataRef.current[i].length;
        }
        return data;
    };
    function encodePCM() {
        let bytes = decompress(),
            sampleBits = oututSampleBits,
            offset = 0,
            dataLength = bytes.length * (sampleBits / 8),
            buffer = new ArrayBuffer(dataLength),
            data = new DataView(buffer);

        if (sampleBits === 8) {
            for (var i = 0; i < bytes.length; i++, offset++) {
                var s = Math.max(-1, Math.min(1, bytes[i]));
                var val = s < 0 ? s * 128 : s * 127;
                val = parseInt(val + 128);
                data.setInt8(offset, val, true);
            }
        } else {
            for (var i = 0; i < bytes.length; i++, offset += 2) {
                var s = Math.max(-1, Math.min(1, bytes[i]));
                data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }
        }

        return data;
    }
    const getToken = () => {
        axios
            .get('/audio_recorder/token')
            .then(response => {
                if (response.data.serverUrl) {
                    wsRef.current = new WebSocket(response.data.serverUrl)
                    wsRef.current.onopen = function (e) {
                        // console.log("Connection established!");
                    };
                    wsRef.current.onmessage = function (e) {
                        let response = JSON.parse(e.data);
                        // console.log(response)
                        if (!response?.pipe?.asr_final && response?.pipe?.asr_sentence) {
                            onChange(response?.pipe?.asr_sentence)
                            if (mode == "debug") {
                                setPreview(response?.pipe?.asr_sentence)
                            }
                        }
                        if (response?.pipe?.asr_final && response?.pipe?.asr_sentence) {
                            onReceive(response?.pipe?.asr_sentence, dayjs().second(response?.pipe?.asr_end_time * -1 + response?.pipe?.asr_begin_time), dayjs())
                            if (mode == "debug") {
                                setOutput(pre => [...pre, response?.pipe?.asr_sentence])
                                setPreview('')
                            }
                        }
                    };
                }
            })
    }
    useEffect(() => {
        getToken()
    }, [])

    useEffect(() => {
        if (forceRecord) {
            start()
            setFroceRecord(false)
        }
    }, [forceRecord])


    useEffect(() => {
        if (forceStopRecord) {
            end()
            setForceStopRecord(false)
        }
    }, [forceStopRecord])

    return (<>
        {/* <Row style={{ "padding": "10px" }}>
            <Col>
                <h1>音量大小設定：</h1>
            </Col>
            <Col>
                <input min={0} type="number" defaultValue={6} onInput={(e) => { gainNode.current.gain.value = e.target.value }} />
            </Col>

        </Row>
        <Row style={{ "padding": "10px" }}>
            <Col>
                <h1>音量大小顯示：</h1>
            </Col>
            <Col>
                <h1>{volume}</h1>
            </Col>
        </Row>
        <Row style={{ "padding": "10px" }}>
            <Col>
                <h1>錄音大小顯示 : </h1>
            </Col>
            <Col>
                <h1 >{chunkVolume}</h1>

            </Col>
        </Row> */}
        {!recording && (<>
            <Button onClick={start} {...startProps}>{startTitle}</Button>
        </>)}
        {recording && (<>
            <Space>
                <Button onClick={end} {...endProps}>{endTitle}</Button>
                <Typography.Text style={{ color: 'red' }}>
                    ◉
                </Typography.Text>
                <Typography.Text style={{ color: 'rgb(77,167,205)' }}>
                    語音辨識中...
                </Typography.Text>
            </Space>
        </>)}
        {output.map(map_item => (<>
            <p>{map_item}</p>
        </>))}
        {preview}
    </>)
}

const Demo = () => {
    const [state, setState] = useState()
    const [VolumeChange, setVolumeChange] = useState()
    const volumeChange = (state, average) => {
        setState(state)
        setVolumeChange(average)
    }

    return (
        <>
            <h1>VolumeChange:{VolumeChange} <br />state:{state}</h1>
            <Recorder onVolumeChange={volumeChange} />

        </>
    )
}
export default Recorder